import { useNavigate } from 'react-router-dom';
import { ParentProfile } from '../components/ParentProfile';
export const ParentProfilePage = () => {
  const navigate = useNavigate();
  return (
    <ParentProfile
      fromMenu={true}
      onBackClick={() => {
        navigate(-1);
      }}
      onSuccess={() => {}}
    ></ParentProfile>
  );
};
